import { __decorate as e, __classPrivateFieldGet as t, __classPrivateFieldSet as s } from "tslib";
import { LitElement as i, html as l } from "lit";
import { property as n } from "lit/decorators.js";
import r from "../../styles/global-styles.js";
import { stylesBase as o, styles1177 as p, stylesInera as a, stylesIneraLegacy as d } from "./header-mobile-menu-styles.js";
var u, h, c, f, m, y;
class b extends i {
  constructor() {
    super(...arguments), u.set(this, !1), h.set(this, !1), c.set(this, !1), f.set(this, !1), m.set(this, void 0), y.set(this, "Meny"), this.closeMenu = () => {
      this.expanded && this.toggleExpanded();
    };
  }
  get expanded() {
    return t(this, u, "f");
  }
  set expanded(e) {
    s(this, u, e, "f");
  }
  get persistent() {
    return t(this, h, "f");
  }
  set persistent(e) {
    s(this, h, e, "f");
  }
  get unresponsive() {
    return t(this, c, "f");
  }
  set unresponsive(e) {
    s(this, c, e, "f");
  }
  get fluid() {
    return t(this, f, "f");
  }
  set fluid(e) {
    s(this, f, e, "f");
  }
  get type() {
    return t(this, m, "f");
  }
  set type(e) {
    s(this, m, e, "f");
  }
  get label() {
    return t(this, y, "f");
  }
  set label(e) {
    s(this, y, e, "f");
  }
  firstUpdated(e) {
    super.firstUpdated(e), this.querySelector("ids-mobile-menu-avatar")?.setAttribute("slot", "menu-link"), this.querySelectorAll("ids-mobile-menu-item")?.forEach(e => {
      e.setAttribute("slot", "menu-link");
    }), this.persistent || this.setupLinkClicks(), this.setupProperties();
  }
  setupProperties() {
    const e = this.closest("ids-header");
    this.setAttribute("type", e.getAttribute("type")), null !== e.getAttribute("unresponsive") && (this.unresponsive = !0), null !== e.getAttribute("fluid") && (this.fluid = !0);
  }
  setupLinkClicks() {
    let e = this.querySelectorAll("a");
    e?.forEach(e => e.addEventListener("click", this.closeMenu));
  }
  toggleExpanded() {
    let e;
    this.expanded = !this.expanded, e = this.expanded ? new CustomEvent("expanded") : new CustomEvent("closed"), this.dispatchEvent(e);
  }
  renderItems() {
    return this.expanded ? l`<ids-row class="mobile-menu-items"><slot name="menu-link"></slot></ids-row>` : l``;
  }
  render() {
    return l`<button aria-label="${this.label}" aria-expanded="${this.expanded}" @click="${this.toggleExpanded}" class="btn-no-styles clickable menu-btn" justify="center" align="center"><ids-col cols="auto"><div class="lines-button x ${this.expanded ? "close" : ""}"><span class="lines"></span></div></ids-col><ids-col class="menu-txt" cols="auto"><slot></slot></ids-col></button> ${this.renderItems()}`;
  }
}
u = new WeakMap(), h = new WeakMap(), c = new WeakMap(), f = new WeakMap(), m = new WeakMap(), y = new WeakMap(), b.styles = [r, o, p, a, d], e([n({
  type: Boolean,
  reflect: !0
})], b.prototype, "expanded", null), e([n({
  type: Boolean
})], b.prototype, "persistent", null), e([n({
  type: Boolean,
  reflect: !0
})], b.prototype, "unresponsive", null), e([n({
  type: Boolean,
  reflect: !0
})], b.prototype, "fluid", null), e([n({
  type: String,
  reflect: !0
})], b.prototype, "type", null), e([n()], b.prototype, "label", null);
export { b as IDSHeaderMobileMenu };